import { useEffect } from 'react';
import { useFormik } from 'formik';
import _ from 'lodash';
import { useDebounce } from 'react-use';
import { useGetBrokerMaster } from 'views/components/pages/accountEstablishment/hooks';
import {
  DepositAccountFormikType,
  depositAccountInfoValidation,
  depositAccountInfoInitialValues,
  depositAccountInfoOnSubmit,
} from 'views/utils/accountEstablish';
import { AccountInfoUpdateRequestParam, useAccountInfoUpdateStore } from './useUpdatePage';

export const useDepositAccountUpdate = () => {
  const { param, add } = useAccountInfoUpdateStore();
  const initialValues = depositAccountInfoInitialValues(param);
  const onSubmit = depositAccountInfoOnSubmit<AccountInfoUpdateRequestParam>(param, add);

  const formik: DepositAccountFormikType = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: depositAccountInfoValidation,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit,
  });

  const { bankMaster, getBankMaster } = useGetBrokerMaster(
    formik.values.isYuchoBank ? formik.values.bankCodeOfYucho : formik.values.bankCode,
    formik.values.isYuchoBank ? formik.values.branchCodeOfYucho : formik.values.branchCode,
  );

  const [, cancel] = useDebounce(
    () => {
      if (formik.values.isYuchoBank && formik.values.bankCodeOfYucho === '' && formik.values.branchCodeOfYucho === '')
        return;
      if (!formik.values.isYuchoBank && formik.values.bankCode === '' && formik.values.branchCode === '') return;
      getBankMaster();
    },
    1000,
    [formik.values.bankCodeOfYucho, formik.values.bankCode, formik.values.branchCodeOfYucho, formik.values.branchCode],
  );

  useEffect(() => {
    if (!bankMaster.data?.GetBrokerMaster) return;
    const [bankNameStr, branchNameStr] = formik.values.isYuchoBank
      ? ['bankNameOfYucho', 'branchNameOfYucho']
      : ['bankName', 'branchName'];
    formik.setFieldValue(bankNameStr, bankMaster.data?.GetBrokerMaster?.BrokerName);
    formik.setFieldValue(branchNameStr, bankMaster.data?.GetBrokerMaster?.BranchName);
  }, [bankMaster]);

  return {
    formik,
  };
};
